import React, { useState } from 'react';
import './Form_modal.css'; // CSS file for styling
import axios from "axios"; 
import { config } from "../../../confi";
import Spinner from '../../Loader/Spinner';
import Swal from 'sweetalert2';
import 'sweetalert2/dist/sweetalert2.css';


const Form_Modals = (prop) => {

const {cash,cheq_no,cheque_amount,date,amount} = prop.dataObj
const balance_amount = prop.balance
const miti_id = prop.mitiid
const  Index_id = prop. index_id
const setLoading = prop.setLoading
const reload_fn = prop.reload_fn
const setmember_data = prop.setmember_data
const datapass = prop.datapass
const state_update = prop.state_update



    const [recieve_date, setrecieve_date] = useState(date);
    const [Cash,setCash] = useState(cash !== undefined ? + cash:0);
    const [Cheque_amount,setCheque_amount] = useState(cheque_amount !== undefined ? + cheque_amount:0);
    const [Cheque_no,setCheque_no] = useState(cheq_no !== undefined ? cheq_no :'');
    const [balance,Setbalance] =useState(+balance_amount + Number(amount))
    const [msg ,Setmsg] = useState(false)



    const Input_handler = (e)=>{

         if(e.target.name ==="date_recieve"){

            setrecieve_date(e.target.value)
         }
       
         if(e.target.name ==="cash"){

          setCash(e.target.value)

         }


         if(e.target.name ==='cheque_amount'){

            setCheque_amount(e.target.value)
         }

         if(e.target.name ==='cheque_no'){

            setCheque_no(e.target.value)
         }


    }


  
    const submit_handler = async () =>{

    try{

         let el = {}

         if(Cash){
              
            el.cash = Cash
 
         }

         if(Cheque_amount){

            el.cheque_amount = Cheque_amount
         }

           if(Cheque_no && Cheque_amount){

            el.cheq_no = Cheque_no
           }

          if(recieve_date){


            el.date = recieve_date 
          }


            if(Cash || Cheque_amount){

                el.amount =  (+Cash) + (+Cheque_amount)
            }


              //  let difference =  (cash !== undefined ? + cash:0) + (cheque_amount !== undefined ? + cheque_amount:0) - (+Cash) + (+Cheque_amount) 


        // let balance = balance_amount - difference

        let balanced = +balance - (+el.amount)
        // console.log(balanced)

let form_data = {
     obj:el,
     balances:balanced,
     miti_id:miti_id,
     index_id:Index_id

}

let reqbody = JSON.stringify({
    fn: "common_fun",
    an: "up_pa_in",
    payload: form_data,
  });


// console.log(form_data)

        setLoading(true)

        const response = await axios.post(
            `${config.apiBaseURL}/root`,
            { data: reqbody },
            {
              headers: { "Content-Type": "application/json" },
            }
          );

          // console.log(response)
          if (response.status === 200 && response.data.status === "0") {
            Swal.fire({
              icon: 'success',
              title: 'Updated!',
              text: 'Amount has been updated successfully.',
              timer: 2000, // The alert will automatically close after 2 seconds
            });
            reload_fn()
            // FetchHandler(miti_id)
           setLoading(false)
           prop.SetForm_modal_show(false)
          }
          else{
            setLoading(false)
             Setmsg(true)
          }

    }

    catch(err){
        setLoading(false)
             Setmsg(true)
        console.log(err)

    }



    }




    

  // async function FetchHandler  (miti_row_id) {


  

  

  //   let reqbody = JSON.stringify({
  //     fn: "common_fun",
  //     an: "fe_one_miti",
  //     payload: { miti_id: miti_row_id },
  //   });


  //   try {



  //     const response = await axios.post(
  //       `${config.apiBaseURL}/root`,
  //       { data: reqbody },
  //       {
  //         headers: { "Content-Type": "application/json" },
  //       }
  //     );
  //     // console.log(response.data);

  //     if (response.status === 200 && response.data.status === "0") {
  //       if (response.data.data.length > 0) {
  //         // console.log(response.data.data);
  //         setmember_data(response.data.data[0]);
  //         datapass(response.data.data[0])
        
  //         // setShow(true);
  //       } else {
  //         // setmsg("Not Miti Found");
  //       }
  //     } else {
  //     }
  //   } catch (error) { }
  //   setLoading(false);
  // };




    return (
        <div>

               
            <div className="modal-overlay2">



                <div className="modal-content2">


        { msg && <p style={{textAlign:"center",color:"red"}}> not update please try again</p>}

                    <div className='model-main-content2'>
                     <label> DATE</label>
                    <input type='date'
                    name ='date_recieve'
                    value={recieve_date}
                    onChange={Input_handler}
                    
                    ></input>
                    <label> Cash</label>
                    <input type='text'
                    name='cash'
                      value={Cash}
                      onChange={Input_handler}
                    ></input>
                    <label> Cheque Amount</label>
                    <input type='text'
                    name ='cheque_amount'
                    value={Cheque_amount}
                    onChange={Input_handler}
                    ></input>
                    <label> Cheque no</label>
                    <input type='text'
                    name ='cheque_no'
                    value={Cheque_no}
                    onChange={Input_handler}

                    ></input>
   <div>


<span> <b> Today Received </b> </span>  :

<span> {(Cash !== undefined ? Number(Cash):0 )  +  (Cheque_amount !== undefined ? Number(Cheque_amount):0)}</span>
</div>
                    
                    <div>

{/* 
                    <span> <b>Balance </b></span> : */}
{/*                   
                    <span> {balance -  (cash !== undefined ? + cash:0) + (cheque_amount !== undefined ? + cheque_amount:0) }</span> */}

                    </div>

                    </div>


                    <div className='modal-btn-div2'>
                        <button className='modal-close-button2'onClick={submit_handler}>Submit</button>

                        <button className='modal-close-button2' onClick={()=>{prop.SetForm_modal_show(false)}}>Cancel</button>

                    </div>
                </div>


            </div>

        </div>
    );
};
export default Form_Modals